import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { SearchDirective } from '../../../shared/directives/search';
@Component({
    selector: 'ngx-search-input',
    styleUrls: ['./search-input.component.scss'],
    template: `
    <i class="control-icon ion ion-ios-search"
       (click)="showInput()"></i>
    <input placeholder="Type your search request here..."
           ngxAppSearch
           [class.hidden]="!isInputShown"
           (blur)="hideInput()"
           (search)="onInput($event)">
  `,
    standalone: false
})
export class SearchInputComponent {
  @ViewChild('input', { static: true }) input: ElementRef;

  @Output() search: EventEmitter<string> = new EventEmitter<string>();

  isInputShown = false;

  showInput() {
    this.isInputShown = true;
    this.input.nativeElement.focus();
    console.log(this.input.nativeElement);
  }

  hideInput() {
    this.isInputShown = false;
  }

  onInput(val: string) {
    this.search.emit(val); console.log(this.input.nativeElement);
  }
}
